import './TechSpecs.css';

const SPECS = [
  { category: 'Architecture', detail: 'Cloud-native, microservices-based infrastructure hosted on AWS with 99.99% guaranteed uptime SLA.' },
  { category: 'Security & Compliance', detail: 'SOC2 Type II certified, GDPR compliant, AES-256 data encryption at rest and TLS 1.3 in transit.' },
  { category: 'AI Models', detail: 'Proprietary NLP engine for unbiased parsing, integrated with custom LLMs for dynamic assessment generation.' },
  { category: 'Integrations', detail: 'Native REST APIs, webhooks, and pre-built connectors for Workday, BambooHR, Slack, and MS Teams.' }
];

const TIMELINE = [
  { step: 'Week 1', title: 'Discovery & Configuration', desc: 'We map your existing ATS workflows, configure RBAC permissions, and establish custom competency frameworks.' },
  { step: 'Week 2', title: 'Integration & Testing', desc: 'API keys are connected, historical resume data is ingested, and testing is performed across both admin and candidate portals.' },
  { step: 'Week 3', title: 'Training & Go-Live', desc: 'Dedicated training for hiring managers and recruiters. Platform goes live with full dedicated success manager support.' }
];

export default function TechSpecs() {
  return (
    <section id="techspecs" className="section-divider">
      <div className="section-wrap">
        <div className="tech-grid">
          
          {/* Tech Specs */}
          <div className="specs-container">
            <span className="eyebrow">Under the Hood</span>
            <h2 className="sec-title" style={{ fontSize: '2rem' }}>Enterprise-grade tech.</h2>
            <div className="specs-list">
              {SPECS.map(s => (
                <div key={s.category} className="spec-item">
                  <h4 className="spec-cat">{s.category}</h4>
                  <p className="spec-det">{s.detail}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Implementation Timeline */}
          <div className="implementation-container">
            <span className="eyebrow eyebrow--green">Implementation</span>
            <h2 className="sec-title" style={{ fontSize: '2rem' }}>Deployed in 21 days.</h2>
            <div className="timeline">
              {TIMELINE.map((t, i) => (
                <div key={t.step} className="timeline-item">
                  <div className="timeline-node"></div>
                  <div className="timeline-content">
                    <span className="timeline-step">{t.step}</span>
                    <h4 className="timeline-title">{t.title}</h4>
                    <p className="timeline-desc">{t.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}